import { AppButton } from '@/ui/buttons';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../styled-ui';

const ActionToastSummary = styled.div`
  font-size: var(--small-font-size);
`;

const ActionButton = styled(AppButton)`
  margin-top: var(--semi-medium-padding);
`;

type ToastActionContentProps = {
  icon: ReactNode;
  summary: string;
  detail?: string;
  actionLabel?: string;
  onAction?: () => void;
  onClose?: () => void;
};

export const renderToastActionContent = ({
  icon,
  summary,
  detail,
  actionLabel,
  onAction,
  onClose,
}: ToastActionContentProps) => (
  <>
    <span className="p-toast-message-icon">{icon}</span>
    <div className="p-toast-message-text">
      <FlexContainer direction="column" justify="flex-start" align="flex-start">
        <ActionToastSummary>
          <div className="p-toast-summary">
            {summary}
            {detail && summary ? ': ' : ''}
          </div>
          {detail ? <div className="p-toast-detail">{detail}</div> : null}
        </ActionToastSummary>
        {actionLabel && onAction && (
          <ActionButton
            label={actionLabel}
            severity="underline"
            size="sm"
            onClick={() => {
              onAction();
              onClose?.();
            }}
          />
        )}
      </FlexContainer>
    </div>
  </>
);
